import {i18n} from 'src/shared/config'

/**
 * Размер посылки для внешней формы
 */
export const enum OrderParcelSize {
  ExtraSmall = 'extraSmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  ExtraLarge = 'extraLarge',
  ExtraExtraLarge = 'extraExtraLarge',
}

type Translations = {
  title: string
  weightTitle?: string
  subtitle?: string
}

const PARCEL_SIZE_ORDER_TRANSLATION_MAPPING: Readonly<Record<OrderParcelSize, Translations>> = {
  [OrderParcelSize.ExtraSmall]: {
    title: i18n('form.ndd.parcel.xs.title', 'XS'),
    subtitle: i18n('form.ndd.parcel.xs.subtitle'),
    weightTitle: i18n('form.ndd.parcel.xs.weight-title'),
  },
  [OrderParcelSize.Small]: {
    title: i18n('form.ndd.parcel.s.title', 'S'),
    subtitle: i18n('form.ndd.parcel.s.subtitle'),
    weightTitle: i18n('form.ndd.parcel.s.weight-title'),
  },
  [OrderParcelSize.Medium]: {
    title: i18n('form.ndd.parcel.m.title', 'M'),
    subtitle: i18n('form.ndd.parcel.m.subtitle'),
    weightTitle: i18n('form.ndd.parcel.m.weight-title'),
  },
  [OrderParcelSize.Large]: {
    title: i18n('form.ndd.parcel.l.title', 'L'),
    subtitle: i18n('form.ndd.parcel.l.subtitle'),
    weightTitle: i18n('form.ndd.parcel.l.weight-title'),
  },
  [OrderParcelSize.ExtraLarge]: {
    title: i18n('form.ndd.parcel.xl.title', 'XL'),
    subtitle: i18n('form.ndd.parcel.xl.subtitle'),
    weightTitle: i18n('form.ndd.parcel.xl.weight-title'),
  },
  [OrderParcelSize.ExtraExtraLarge]: {
    title: i18n('form.ndd.parcel.xxl.title', 'XXL'),
    subtitle: i18n('form.ndd.parcel.xxl.subtitle'),
    weightTitle: i18n('form.ndd.parcel.xxl.weight-title'),
  },
}

export const parcelEntries = Object.entries(PARCEL_SIZE_ORDER_TRANSLATION_MAPPING) as unknown as Array<
  [OrderParcelSize, Translations]
>

/**
 * Типы размеров посылок, которые относятся к бизнес-тарифу
 */
export const BUSINESS_PARCEL_SIZES: Readonly<Array<string>> = [OrderParcelSize.ExtraExtraLarge]
